module.exports = __webpack_public_path__ + "media/images/emblems/Muenchenbuchsee-coat_of_arms-8b2da6b51bf2ce735b9efe96bd553d91.svg";